import { render, staticRenderFns } from "./edit-integration-link-form.vue?vue&type=template&id=6c7c4ca0&"
import script from "./edit-integration-link-form.vue?vue&type=script&lang=js&"
export * from "./edit-integration-link-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports